import { z } from 'zod'

export const AssignEmployeesSchema = () => {
  return z.object({
    employeeIds: z.array(z.string()),
  })
}

export type AssignEmployeesSchemaType = z.infer<ReturnType<typeof AssignEmployeesSchema>>
